import { useMemo } from 'react';
import { useLocation } from 'react-router';

export interface NavigationState {
  previousPath: string;
}

const useNavigationState = () => {
  const { pathname } = useLocation();
  const navigationState: NavigationState = useMemo(
    () => ({ previousPath: pathname }),
    [pathname]
  );
  return navigationState;
};

export default useNavigationState;
